<template>
  <div class="section">

    <b-table
      :default-sort-direction="defaultSortDirection"
      default-sort="createdUtc"
      :data="isEmpty ? [] : $store.state.notes"
      :narrowed="false"
      :hoverable="true"
      :selected.sync="selected"
      :paginated="true"
      :per-page="20"
      @select="setActiveRow"
    >

      <template slot-scope="props">
        <b-table-column
          field="createdUtc"
          label="Created"
          sortable
        >
          <span>
            <div>{{ props.row.createdUtc | dateMedium }}</div>
            <div class="is-size-7">{{ props.row.createdUtc | time }}</div>
          </span>
        </b-table-column>

        <b-table-column
          field="stage"
          label="Stage"
          sortable
        >
          <b-icon
            :pack="getStageStyle(props.row.stage)"
            v-bind:icon="getStageStyle(props.row.stage)"
            size="is-small"
          ></b-icon>
          <span>{{ props.row.stage }}</span>
        </b-table-column>

        <b-table-column
          field="address"
          label="Address"
          sortable
        >
          {{ props.row.address }}
        </b-table-column>

        <b-table-column
          field="theNote"
          label="Note"
        >
          {{ props.row.theNote }}
        </b-table-column>

        <b-table-column
          field="controls"
          label=""
          centered
        >
          <div class="columns">
            <div class="column">
              <b-tooltip label="Edit note">
                <a
                  class="fas fa-edit"
                  @click="editNote(props.row)"
                ></a>
              </b-tooltip>
            </div>
            <div class="column">
              <b-tooltip label="Delete note">
                <a
                  class="fas fa-trash"
                  @click="deleteNote(props.row)"
                ></a>
              </b-tooltip>
            </div>
          </div>
        </b-table-column>

      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="emoticon-happy"
                size="is-large"
              >
              </b-icon>
            </p>
            <p>No notes yet</p>
          </div>
        </section>
      </template>

    </b-table>

  </div>
</template>

<script>
import Helpers from "@/services/Helpers.js";

export default {
  props: {
    open: false
  },

  data() {
    return {
      activeConnection: undefined,
      selected: undefined,
      isEmpty: undefined,
      defaultSortDirection: "desc"
    };
  },

  mounted() {
    console.log("mounted()");
    var userId = this.$store.getters.session.user.id;
    var includeInactive = false;
    this.$store.dispatch("getNotes", {
      userId,
      includeInactive
    });
  },

  methods: {
    async editNote() {
      console.log("editNote()", this.$store.state.noteEdit);
      await this.$store.commit("SET_NOTE_EDIT_ISACTIVE", true);
    },

    setActiveRow(row) {
      console.log("setActiveRow", row);
      this.activeConnection = row;

      // Prepare to edit, in case the user clicks edit.
      this.$store.state.noteEdit.originalNote = row;
      this.$store.state.noteEdit.note = row;
    },

    getStageStyle(stage) {
      return Helpers.getStageStyle(stage);
    },

    deleteNote(note) {
      console.log("deleteNote()", note);
      this.$buefy.dialog.confirm({
        title: "Deleting note",
        message: `<b>Delete this note?</b><br><br>${note.theNote}`,
        confirmText: "Delete Note",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          var propertyId = note.propertyId;
          var noteId = note.id;
          this.$store.dispatch("deletePropertyNote", { propertyId, noteId });
          this.showSuccess(`Note deleted`);
        }
      });
    }
  }
};
</script>

<style>
</style>
